import {
  padding20,
  mainTextWhite,
  mainTextGray,
  blueMain,
  headerHeight,
  blackMainHover,
  navbarDivider,
  blackMainLightHover,
} from '../../../theme';

const styles = () => ({
  root: {
    display: 'flex',
    position: 'relative',
    paddingLeft: padding20,
    '&:before': {
      position: 'absolute',
      top: '50%',
      left: 0,
      display: 'block',
      width: 1,
      height: 24,
      backgroundColor: navbarDivider,
      transform: 'translateY(-50%)',
      content: '""',
    },
  },
  nav: {
    color: mainTextGray,
    fontWeight: 400,
    borderBottom: '3px solid transparent',
    backgroundColor: 'transparent',
    height: headerHeight,
    '&:hover': {
      color: mainTextWhite,
      backgroundColor: blackMainHover,
    },
    '& .MuiSvgIcon-root': {
      transition: 'transform 110ms,fill 110ms,-webkit-transform 110ms',
    },
  },
  open: {
    color: mainTextWhite,
    backgroundColor: blackMainHover,
    '& .MuiSvgIcon-root': {
      transform: 'rotate(180deg)',
    },
  },
  active: {
    '&:after': {
      position: 'absolute',
      content: '""',
      bottom: -2,
      left: 0,
      right: 0,
      borderBottom: `3px solid ${blueMain}`,
    },
  },
  dropdownContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  dropdown: {
    boxShadow: '0 4px 8px 0 rgb(0 0 0 / 50%)',
    zIndex: 8000,
    position: 'absolute',
    backgroundColor: blackMainHover,
    width: 200,
    padding: 0,
    color: mainTextGray,
    '& a:hover': {
      color: mainTextWhite,
      backgroundColor: blackMainLightHover,
    },
    '& span': {
      fontSize: 14,
    },
  },
  profile: {
    position: 'fixed',
    right: 0,
    '& > div': {
      right: 0,
      width: 300,
    },
  },
  icon: {
    color: mainTextGray,
    fontSize: 20,
  },
  user: {
    position: 'relative',
    width: 45,
    height: 45,
    overflow: 'hidden',
    borderRadius: '50%',
    '& img': {
      width: '100%',
      height: 'auto',
    },
  },
});

export default styles;
